export default __webpack_public_path__ + "static/media/edit-alt.cad4f1ae.svg";